import React from "react";
import PropTypes from "prop-types";
import { selectMainImageGroup } from "helpers/product-image-helpers";
import ProductImagePath from "../../../helpers/product-image-path";
import {
  flagsAndExperimentNames,
  flagsAndExperimentsPropType,
  withFlagsAndExperiments,
} from "../hoc/with-flags-and-experiments";
import { compose } from "redux";
import FlagsAndExperimentsActions from "../../../actions/flags-and-experiments-actions";
import { connect } from "react-redux";
import sharedActions from "../../../actions/shared-actions";
import { AiSearchFeedbackModal } from "./ai-search-feedback-modal";
import ActionLogger from "action-logger";
import AiSearchFeedbackConfirmationModal from "./ai-search-feedback-confirmation-modal";
import { getUserId } from "../hoc/with-user-data";
import RtrImage from "../shared/rtr-image";

class GridHeader extends React.Component {
  static propTypes = {
    extraClass: PropTypes.string,
    deviceId: PropTypes.string,
    dispatch: PropTypes.func,
    displayModal: PropTypes.func.isRequired,
    displayedModal: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    flagsAndExperiments: flagsAndExperimentsPropType,
    hideCount: PropTypes.bool,
    isSearchResultGrid: PropTypes.bool,
    isMobileViewport: PropTypes.bool,
    resultsCount: PropTypes.number,
    searchText: PropTypes.string,
    shortlistName: PropTypes.string,
    subject: PropTypes.object,
    title: PropTypes.string,
    description: PropTypes.string,
    userData: PropTypes.object,
  };

  static defaultProps = {
    hideCount: false,
  };

  componentDidMount() {
    this.props.dispatch(
      FlagsAndExperimentsActions.fetchFlagOrExperiment(flagsAndExperimentNames.DISCO_SEARCH_AI_MVP_STOREFRONT_UX)
    );
  }

  getSubjectProductImageSrc = () => {
    var images;

    if (!this.props.subject || this.props.subject.type !== "product") {
      return;
    }

    images = this.props.subject.images;

    return ProductImagePath + selectMainImageGroup(images)["70x"];
  };

  openAiSearchFeedbackModal = () => {
    this.props.displayModal(AiSearchFeedbackModal.modalName);
  };

  getSubtitleHTML = () => {
    if (this.props.subject?.headerText) {
      return <p className="grid-header-blurb mq__no-mobile">{this.props.subject.headerText}</p>;
    }
  };

  getImageHtml = () => {
    var titleImageSrc = this.getSubjectProductImageSrc(),
      imageClass;

    if (this.props.subject?.headerImageURL) {
      imageClass = this.props.subject.headerText ? "grid-header-designer-image" : "grid-header-designer-image-only";
      return (
        <RtrImage
          alt={this.props.subject.displayName}
          className={imageClass + " mq__desktop"}
          src={this.props.subject.headerImageURL}
        />
      );
    } else if (titleImageSrc) {
      return (
        <div className="grid-header-product-image">
          <RtrImage src={titleImageSrc} alt="" />
        </div>
      );
    }
  };

  closeModal = () => {
    this.props.displayModal(false);
  };

  onClickFeedbackSubmit = (selectedFeedback, text) => {
    const feedback = {
      search_text: this.props.searchText,
      selected_feedback: selectedFeedback || "n/a",
      user_id: getUserId(this.props.userData) || -1,
      device_id: this.props.deviceId,
      action: "click_feedback_response_option",
      object_type: "ai_search_feedback_modal",
      text_feedback: text || "n/a",
    };
    ActionLogger.logAction(feedback);
    this.props.displayModal(AiSearchFeedbackConfirmationModal.modalName);
  };

  renderAISearchFeedBackButton() {
    if (
      this.props.flagsAndExperiments?.[flagsAndExperimentNames.DISCO_SEARCH_AI_MVP_STOREFRONT_UX] &&
      this.props.isSearchResultGrid
    ) {
      return (
        <>
          <div className="grid-header-blurb ai-search-feedback">
            <span>{"How's your search experience? "}</span>
            <button className="ai-search-feedback-button" onClick={this.openAiSearchFeedbackModal}>
              {"Let us know"}
            </button>
          </div>
          <AiSearchFeedbackModal
            key="aiSearchFeedbackModal"
            onChange={this.onClickFeedbackSubmit}
            isMobileViewport={this.props.isMobileViewport}
            onRequestClose={this.closeModal}
            displayedModal={this.props.displayedModal}
          />
          <AiSearchFeedbackConfirmationModal
            className="ai-search-feedback-confirmation-modal"
            key="aiSearchFeedbackConfirmationModal"
            onRequestClose={this.closeModal}
            isMobileViewport={this.props.isMobileViewport}
            displayedModal={this.props.displayedModal}
          />
        </>
      );
    } else {
      return;
    }
  }

  renderCount = () => {
    if (!this.props.hideCount) {
      return <span className="h3 secondary-copy">&nbsp;({this.props.resultsCount})</span>;
    }
  };

  getTitleForTextSearch() {
    const { searchText } = this.props;

    if (searchText && searchText.trim().length) {
      return `Results for “${searchText}”`;
    }
  }

  render() {
    const { shortlistName, title: defaultTitle, extraClass, description } = this.props;
    const title = this.getTitleForTextSearch() || shortlistName || defaultTitle;
    const extraStyle = extraClass ? " " + extraClass : "";

    return (
      <div className={"grid-header" + extraStyle} data-test-id="grid-header">
        {this.getImageHtml()}
        <div className="grid-header-meta">
          <div className={`grid-header-meta__col ${!description ? "grid-header-meta__col--centered" : ""}`}>
            <h1 className="grid-name h3"> {title}</h1>
          </div>

          {/* PLACEHOLDER there is a follow up ticket to populate this copy: TUX-389 */}
          {!!description && (
            <div className="grid-header-meta__col">
              <p>{description}</p>
            </div>
          )}

          {this.getSubtitleHTML()}
          {this.renderAISearchFeedBackButton()}
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  fetchFlagTreatment: () => {
    dispatch(
      FlagsAndExperimentsActions.fetchFlagOrExperiment(flagsAndExperimentNames.DISCO_SEARCH_AI_MVP_STOREFRONT_UX)
    );
  },
  displayModal: sharedActions.displayModal,
});
export default compose(
  connect(null, mapDispatchToProps()),
  withFlagsAndExperiments(flagsAndExperimentNames.DISCO_SEARCH_AI_MVP_STOREFRONT_UX)
)(GridHeader);
